@if (showPopup) {
<div class="year-picker-overlay">
  <div class="year-picker-popup" 
       [id]="uniqueId"
       (click)="$event.stopPropagation()">
    
    <!-- Year Selector Input -->
    <!-- <div class="year-selector">
      <div class="input-group">
        <input type="number" 
               class="form-control year-input" 
               [(ngModel)]="selectedYear"
               (ngModelChange)="onYearInputChange($event)"
               placeholder="Enter year"
               min="1900"
               max="9999">
        <span class="input-group-addon calendar-icon">
          <i class="fa fa-calendar"></i>
        </span>
      </div>
    </div> -->

    <!-- Header -->
    <div class="year-picker-header">
      <button type="button" 
              class="nav-btn" 
              (click)="navigateYears('prev')"
              [disabled]="currentRangeStart <= minYear">
        <i class="fa fa-chevron-left"></i>
      </button>
      
      <span class="year-range-label">{{ getYearRangeLabel() }}</span>
      
      <button type="button" 
              class="nav-btn" 
              (click)="navigateYears('next')"
              [disabled]="currentRangeStart + yearsPerPage > maxYear">
        <i class="fa fa-chevron-right"></i>
      </button>
    </div>

    <!-- Year Grid -->
    <div class="year-grid">
      @for (row of yearGrid; track $index) {
<div class="year-row">
        @for (year of row; track $index) {
<button type="button"
               
                class="year-btn"
                [class.selected]="isYearSelected(year)"
                [class.disabled]="isYearDisabled(year)"
                [disabled]="isYearDisabled(year)"
                (click)="selectYear(year)">
          {{ year }}
        </button>
}
      </div>
}
    </div>

    <!-- Footer Actions -->
    <div class="year-picker-footer">
      <button type="button" class="year-action-btn today-btn" (click)="selectToday()">
        <i class="fa fa-calendar"></i> Today
      </button>
      <button type="button" class="year-action-btn clear-btn" (click)="clearYear()">
        <i class="fa fa-times"></i> Clear
      </button>
      <button type="button" class="year-action-btn close-btn" (click)="closePopup()">
        <i class="fa fa-check"></i> Close
      </button>
    </div>

  </div>
</div>
}

